module.exports = __webpack_public_path__ + "assets/broken-image.b3288e0a.svg";